"use strict";

module.exports = {
  FILE: 'FILE',
  RSS: 'RSS'
};